<template>
<div style="height: 100%">
  <div v-if="!addShow" style="height: 100%">
    <el-row style="height: 100%">
      <el-col :span="12" style="height: 100%">
        <div style="height: 50px;margin-left: 20px">
          <el-button type="success" @click="addElectronic">创建围栏</el-button>
        </div>
        <div style="height: calc(100% - 50px);margin-left: 20px;overflow-y: auto">
          <el-table class="handle-list" :data="tableData" border height="100%" @row-click="handleRowClick" :row-class-name="tableRowClassName">
            <el-table-column prop="circle_name" label="围栏名称" min-width="80" align="center"></el-table-column>
            <el-table-column label="类型" min-width="60" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.circle_type === 1">圆形</span>
                <span v-if="scope.row.circle_type === 2">多边形</span>
              </template>
            </el-table-column>
            <el-table-column label="行为" min-width="70" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.circle_in_out === 2">禁止进入</span>
                <span v-if="scope.row.circle_in_out === 1">禁止离开</span>
              </template>
            </el-table-column>
            <el-table-column prop="circle_sos_count" label="报警次数" width="80" align="center"></el-table-column>
            <el-table-column prop="time" label="使用时间段" width="155" align="center">
              <template slot-scope="scope">
                <span>{{getTimesShow(scope.row.times)}}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100"  class-name="small-padding fixed-width">
              <template slot-scope="scope">
                <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editElectronic(scope.row)"></i>
                <i title="解绑" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delElectronic(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12" style="height: 100%">
        <div style="height: 100%;margin-right: 20px">
          <electronic-map ref="showMap"></electronic-map>
        </div>
      </el-col>
    </el-row>
  </div>
  <div v-else style="height: 100%;">
    <add-edit-electronic v-model="addShow" :electronicObj="electronicObj" @getFatherElectronic="getFatherElectronic"></add-edit-electronic>
  </div>
</div>
</template>

<script>
import electronicMap from './electronicMap.vue'
import addEditElectronic from './addEditElectronic.vue'
import {devicecirclelist, devicecircledelete} from '../../../api/device'

export default {
  name: 'deviceEcircle',
  props: {
    trackObj: {
      type: Object,
      default: null
    }
  },
  components: {electronicMap, addEditElectronic},
  data () {
    return {
      tableData: [],
      tableRowIndex: '',
      tableRow: '',
      addShow: false,
      electronicObj: {
        isAdd: true,
        electronicRow: '',
        deviceRow: ''
      },
      groupArr: [], // 分组
      groupTree: [],
      delObj: ''
    }
  },
  created () {
    this.electronicObj.deviceRow = this.trackObj.deviceRow
    this.getCircleTable()
  },
  methods: {
    getFatherElectronic (obj) {
      if (obj.type === 'close') {
        if (this.tableRow !== '') {
          setTimeout(() => {
            this.$refs.showMap.getStartData(this.tableRow)
          }, 2000)
        }
      } else {
        this.tableRowIndex = ''
        this.tableRow = ''
        this.getCircleTable()
      }
    },
    getCircleTable () {
      let data = {
        did: this.trackObj.deviceRow.id
      }
      devicecirclelist(data).then(res => {
        this.tableData = res.data.circle
        // this.tableRow = this.tableData[0]
        this.$refs.showMap.getStartData(this.tableRow)
        console.log(this.tableData)
      }).catch(() => {})
    },
    addElectronic () {
      this.electronicObj.isAdd = true
      this.electronicObj.electronicRow = ''
      this.addShow = true
    },
    editElectronic (row) {
      this.electronicObj.isAdd = false
      this.electronicObj.electronicRow = row
      this.addShow = true
    },
    delElectronic (row) {
      if (row.id === this.tableRow.id) {
        return
      }
      this.delObj = row
      let name = row.circle_name
      this.$confirm('此操作将永久删除该电子围栏【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        devicecircledelete(data).then(res => {
          this.$message({message: '成功删除', type: 'success'})
          if (this.tableRow.id === row.id) {
            this.tableRowIndex = ''
            this.tableRow = ''
            this.$refs.showMap.getStartData(this.tableRow)
          }
          this.getCircleTable()
        }).catch(() => {})
      }).catch(() => {})
    },
    getTimesShow (times) {
      let time = ''
      for (let i = 0; i < times.length; i++) {
        let tms = times[i].sos_start_time.split(':')
        let tme = times[i].sos_end_time.split(':')
        let tm = tms[0] + ':' + tms[1] + '~' + tme[0] + ':' + tme[1]
        if (time === '') {
          time = tm
        } else {
          time = time + '，' + tm
        }
      }
      return time
    },
    handleRowClick (row) {
      this.tableRowIndex = this.getArrayIndex(this.tableData, row) // 获取当前点击行下标
      // ... 点击当前行，进行的操作
      if (row.id === this.tableRow.id) {
        return
      }
      this.$refs.showMap.getStartData(row)
      this.tableRow = row
      // console.log(row)
    },
    tableRowClassName ({row, rowIndex}) {
      // return 'row-bg'
      // return 'highlight-row'
      if (rowIndex === this.tableRowIndex) {
        return 'highlight-row'
      }
    },
    // 获取一个元素在数组中的下标
    getArrayIndex (arr, obj) {
      let i = arr.length
      while (i--) {
        if (arr[i] === obj) {
          return i
        }
      }
      return -1
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/deviceEcircle.vue